import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Select from 'react-select';
import { countries } from '../../assets/i18n/countries';
import * as Constants from '../../constants';
import React, { useEffect, useState } from 'react';
import './NavBar.css';
import { AuthenticationService } from '../../services/authentication.service';
import EstablecimientoService from '../../services/establecimiento.service';
import { useEstablishment } from '../../Context/EstablishmentContext';
import UsuarioService from '../../services/usuario.service';
import { CgProfile } from "react-icons/cg";
import { FaPowerOff } from "react-icons/fa6";

import PopUpMisDatos from './MisDatos'
import PopUpConfirmLogOut from './ConfirmLogOut';
import { FiMenu } from "react-icons/fi";


const NavBar = ({ currentPath }) => {
	const { t, i18n } = useTranslation("global");
	const { establecimiento, setEstablecimiento } = useEstablishment();
	const navigate = useNavigate();

	const [selectedLanguage, setSelectedLanguage] = useState(countries[0]); // Estado inicial(idioma por defecto)
	const [listaEstablecimientos, setListaEstablecimientos] = useState([]);

	const authenticationService = new AuthenticationService();
	//const userRol = authenticationService.getAuthenticationSession().user.idTipo;//obtiene el rol de usuario
	//const userTipoEmpleado = authenticationService.getAuthenticationSession().user.tipoEmpleado;

	const [seenMisDatos, setSeenMisDatos] = useState(false);
	const [seenConfirmLogOut, setSeenConfirmLogOut] = useState(false);
	const [connectedUser, setConnectedUser] = useState(null);
	const [userRol, setUserRol] = useState(getUserRol());
	const [userTipoEmpleado, setUserTipoEmpleado] = useState(getUserTipoEmpleado());

	useEffect(() => {
		const savedLanguage = localStorage.getItem('language');
		if (savedLanguage) {
			i18n.changeLanguage(savedLanguage);
			const selectedCountry = countries.find(c => c.value === savedLanguage);
			setSelectedLanguage(selectedCountry);
		}
		
		if(authenticationService.getAuthenticationSession() != null && authenticationService.getAuthenticationSession().user != null){
			if(userRol === Constants.ROLE_USUARIO_ADMINISTRADOR) {
				obtenerListaEstablecimientos();
			}else if(userRol === Constants.ROLE_USUARIO_ADMIN_CADENA) {
					obtenerListaEstablecimientosByCadena(authenticationService.getAuthenticationSession().user.cadena.id);
			}else {
					obtenerEstablecimientoById(authenticationService.getAuthenticationSession().user.establecimiento);
			}
	
			const authentication = authenticationService.getAuthenticationSession();
			obtenerUsuarioConectado(authentication.user.id);
			
		}else{
			authenticationService.setAuthenticationSession(null);
			navigate(Constants.ROUTE_NOT_AUTH)
		}

		

	}, [i18n]);
	
	function loadUserAuthenticated() {
		obtenerUsuarioConectado(authenticationService.getAuthenticationSession().user.id);
	}
	
	function getUserRol() {
		if(authenticationService.getAuthenticationSession() != null && authenticationService.getAuthenticationSession().user != null){
			return authenticationService.getAuthenticationSession().user.idTipo;
		}else{
			return null
		}
	}
	
	function getUserTipoEmpleado() {
		if(authenticationService.getAuthenticationSession() != null && authenticationService.getAuthenticationSession().user != null){
			return authenticationService.getAuthenticationSession().user.tipoEmpleado;
		}else{
			return null
		}
	}
	
	function togglePopMisDatos() {
		setSeenMisDatos(!seenMisDatos);
	}
	
	function togglePopupConfirmLogOut() {
		setSeenConfirmLogOut(!seenConfirmLogOut);
	}

	const handleChangeLanguage = (ev) => {
		i18n.changeLanguage(ev.value);
		localStorage.setItem('language', ev.value);  // Guardar el idioma seleccionado en localStorage
		setSelectedLanguage(ev); // Actualizar el estado del selector
	};
	const logout = () => {
		authenticationService.setAuthenticationSession(null);
		navigate(Constants.ROUTE_ROOT);
	};
	
	const obtenerUsuarioConectado = async (id) => {
		await UsuarioService.getUsuarioById(id)
		.then(response => response.json())
		.then(data => {
			setConnectedUser(data);
		})
	}

	const obtenerListaEstablecimientos = async () => {
		await EstablecimientoService.getEstablecimientos()
			.then(response => response.json())
			.then(data => {
				setListaEstablecimientos(data);
				setEstablecimiento(data[0]);
			});
	}
	
	const obtenerListaEstablecimientosByCadena = async (cadena) => {
		await EstablecimientoService.getEstablecimientosByParams('', 1, cadena)
			.then(response => response.json())
			.then(data => {
				setListaEstablecimientos(data);
				setEstablecimiento(data[0]);
			});
	}
	
	const obtenerEstablecimientoById = async (id) => {
		await EstablecimientoService.getEstablecimientoById(id)
			.then(response => response.json())
			.then(data => setEstablecimiento(data));
	}

	const onChangeEstablecimiento = (selectedOption) => {
		setEstablecimiento(selectedOption);

	};
	
	function openNav() {
		document.getElementById("mySidenav").style.minWidth = "270px";
		document.getElementById("mySidenav").style.paddingLeft = "10px";
		document.getElementById("mySidenav").style.paddingRight = "10px";
	}
	
	function closeNav() {
		document.getElementById("mySidenav").style.minWidth = "0px";
		document.getElementById("mySidenav").style.paddingLeft = "0px";
		document.getElementById("mySidenav").style.paddingRight = "0px";
	}
	
	
	//Configuración de colores para Selects de Elegir establecimiento e Idioma
	const colorFiltrosEligeEstabl = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
	}
	
	const colorFiltrosIdioma = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
	}
	
	
	// Para mostrar el color de fondo de la opción elegida en la lista de opciones
	const getOptionValueEstabl = option => option.id;
	

	return (
		<header className="NavBar">
		<section className="principal-container">

			<div className="header-buttons">
				<div className="container-enlaces-navbar">
				
					{(userRol === Constants.ROLE_USUARIO_ADMINISTRADOR) && (
						<NavLink to={Constants.ROUTE_CADENAS} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.cadenas")}
						</NavLink>
					)}
					
					{(userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR)  && (
						<NavLink to={Constants.ROUTE_ESTABLECIMIENTOS} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.datosEstablecimiento")}
						</NavLink>
					)}
					
					{((userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado !=null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) 
					|| userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR) && (
						<NavLink to={Constants.ROUTE_HABITACIONES} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.habitaciones")}
						</NavLink>
					)}
					
					{((userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado !=null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_MANTENIMIENTO) 
					|| userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR) && (
						<NavLink to={Constants.ROUTE_CAMAS} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.camas")}
						</NavLink>
					)}

					{((userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado !=null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) 
					|| userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR) && (
						<NavLink to={Constants.ROUTE_PERSONAL} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.personal")}
						</NavLink>
					)}
					
					{((userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado !=null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_MANTENIMIENTO) 
					|| userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR) && (
						<NavLink to={Constants.ROUTE_DESCARGA} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.descarga")}
						</NavLink>
					)}	
				</div>


				{/*si la ruta actual es diferente a establecimientos mostramos el selector de establecimiento */}
				<div className="container-filtroElegirEstablecimiento">
					{((currentPath !== Constants.ROUTE_ESTABLECIMIENTOS && currentPath !== Constants.ROUTE_CADENAS) && (userRol !== Constants.ROLE_USUARIO_TRABAJADOR && userRol !== Constants.ROLE_USUARIO_GESTOR)) && (

						<Select
							getOptionValue={getOptionValueEstabl}
							className={'filtroElegirEstablecimiento'}
							placeholder={t("app.label.seleccionar")}
							value={establecimiento}
							onChange={onChangeEstablecimiento}
							options={listaEstablecimientos}
							isSearchable={false}
							formatOptionLabel={establecimiento => (
									<span>{establecimiento.nombre}</span>
							)}
							styles={colorFiltrosEligeEstabl}
						/>

					)}
				</div>

				<div className="container-elegirIdioma">
					<div className="contentHeader_selectLang">
						<div>
							<Select
								className={'filtroSelect'}
								value={selectedLanguage}
								options={countries}
								onChange={handleChangeLanguage}
								getOptionLabel={(option) => (
									<div className="country-option">
										<img src={option.image} alt="country" className="imgSelectLang" />
										<span className="labelSelectLang">{option.label}</span>
									</div>
								)}
								styles={colorFiltrosIdioma}
							/>
						</div>
					</div>
					
					<button className="btn-Micuenta" onClick={togglePopMisDatos}><CgProfile size={20} /><p className="txt-btn-Micuenta">{t("app.header.enlaces.miCuenta")}</p></button>
					<a className="link-logout" onClick={togglePopupConfirmLogOut}><FaPowerOff /><p className="txt-link-logout">{t("app.header.enlaces.salir")}</p></a>
				</div>
				
				<div className="container-menuNavigation">
				<button className="btnMenuNavigation" onClick={openNav}><FiMenu className="iconMenuNavigation"/></button>
				</div>
				
			</div>
			
			{seenMisDatos ? <PopUpMisDatos loadUserAuthenticated={loadUserAuthenticated} toggle={togglePopMisDatos} connectedUser={connectedUser} /> : null}
			
			{seenConfirmLogOut ? <PopUpConfirmLogOut logout={logout} toggle={togglePopupConfirmLogOut}/> : null}
			</section>
			
			<div id="mySidenav" className="sidenav">
				<div className="container-closeSideNav">
					<button href="javascript:void(0)" className="close-sideNav" onClick={closeNav}>&times;</button>
				</div>
			  
			  
			  <div className="group-links-sideNav">
					{(userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR)  && (
						<NavLink to={Constants.ROUTE_ESTABLECIMIENTOS} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.datosEstablecimiento")}
						</NavLink>
					)}
					
					{((userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado !=null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_MANTENIMIENTO) 
					|| userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR) && (
						<NavLink to={Constants.ROUTE_CAMAS} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.camas")}
						</NavLink>
					)}

					{((userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado !=null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) 
					|| userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR) && (
						<NavLink to={Constants.ROUTE_PERSONAL} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.personal")}
						</NavLink>
					)}
					
					{((userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado !=null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) 
					|| userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR) && (
						<NavLink to={Constants.ROUTE_HABITACIONES} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.habitaciones")}
						</NavLink>
					)}
					
					{(userRol === Constants.ROLE_USUARIO_ADMINISTRADOR) && (
						<NavLink to={Constants.ROUTE_CADENAS} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.cadenas")}
						</NavLink>
					)}
					
					{((userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado !=null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_MANTENIMIENTO) 
					|| userRol === Constants.ROLE_USUARIO_ADMINISTRADOR || userRol === Constants.ROLE_USUARIO_ADMIN_CADENA || userRol === Constants.ROLE_USUARIO_GESTOR) && (
						<NavLink to={Constants.ROUTE_DESCARGA} className={({ isActive }) => isActive ? 'header-link active' : 'header-link'}>
							{t("app.header.enlaces.descarga")}
						</NavLink>
					)}

				</div>
				
			  <div className="selectEligeEstabl-sideNav">
					{((currentPath !== Constants.ROUTE_ESTABLECIMIENTOS && currentPath !== Constants.ROUTE_CADENAS) && (userRol !== Constants.ROLE_USUARIO_TRABAJADOR && userRol !== Constants.ROLE_USUARIO_GESTOR)) && (

						<Select
							getOptionValue={getOptionValueEstabl}
							className={'filtroElegirEstablecimiento-sideNav'}
							placeholder={t("app.label.seleccionar")}
							value={establecimiento}
							onChange={onChangeEstablecimiento}
							options={listaEstablecimientos}
							isSearchable={false}
							formatOptionLabel={establecimiento => (
									<span>{establecimiento.nombre}</span>
							)}
							styles={colorFiltrosEligeEstabl}
						/>

					)}
				</div>
				
				<div className="container-eligeIdioma-sideNav">
							<Select
								className={'filtroSelect-sideNav'}
								value={selectedLanguage}
								options={countries}
								onChange={handleChangeLanguage}
								getOptionLabel={(option) => (
									<div className="country-option">
										<img src={option.image} alt="country" className="imgSelectLang" />
										<span className="labelSelectLang">{option.label}</span>
									</div>
								)}
								styles={colorFiltrosIdioma}
							/>
					
					<button className="btn-Micuenta-sideNav" onClick={togglePopMisDatos}><CgProfile size={20} /><p className="txt-btn-Micuenta">{t("app.header.enlaces.miCuenta")}</p></button>
					<a className="link-logout-sideNav" onClick={togglePopupConfirmLogOut}><FaPowerOff /><p className="txt-link-logout">{t("app.header.enlaces.salir")}</p></a>
				</div>
				
			</div>
		</header>
	);
};

export default NavBar;